import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/auth.guard';
import { EduNavbarComponent } from './navbar/edu-navbar/edu-navbar.component';
import { AccessDeniedComponent } from './shared/access-denied/access-denied.component';
import { OidcCallbackComponent } from './auth/oidc-callback/oidc-callback.component';

const routes: Routes = [

  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
  },
  {
    // Landing route for the QLM OIDC redirect (Authorization Code + PKCE callback).
    path: 'auth/callback',
    component: OidcCallbackComponent,
  },
  {
    path: 'access-denied',
    component: AccessDeniedComponent,
  },
  {
    path: 'portal',
    component: EduNavbarComponent,
    canActivateChild: [AuthGuard],
    children: [
      {
        path: 'pseudocode',
        loadChildren: () => import('./translator/translator.module').then(m => m.TranslatorModule)
      },
    ]
  },
  {
    path: '**',
    redirectTo: 'login',
  }
];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
